import { useState, useEffect } from 'react';
import { Menu, X, Instagram, Twitter, Facebook, Linkedin } from 'lucide-react';

import '@/App.css';
import logo from '@/assets/logo.jpeg';

function Navigation() {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [currentPath, setCurrentPath] = useState('');

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 100);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setCurrentPath(window.location.pathname);
    }, []);

    const navLinks = [
        { name: 'Home', href: '/' },
        { name: 'competitions', href: '/competitions' },
        // { name: 'Leaderboard', href: '/leaderboard' },
        { name: 'Highlights', href: '/highlights' },
        { name: 'About Us', href: '/about' },
        { name: 'Contact Us', href: '/contact' },
    ];

    return (
        <>
<nav
  className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
    isScrolled ? 'pt-3' : 'pt-5'
  }`}
>

  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

    {/* NAV WRAPPER */}
    <div
      className={`relative rounded-[32px] transition-all duration-500 overflow-hidden ${
        isScrolled
          ? 'bg-white/90 backdrop-blur-2xl border border-gray-200 shadow-[0_20px_70px_rgba(0,0,0,0.08)]'
          : 'bg-black/20 backdrop-blur-2xl border border-white/10 shadow-[0_20px_70px_rgba(0,0,0,0.2)]'
      }`}
    >

      {/* Decorative Glow */}
      <div className="absolute -top-10 right-10 w-40 h-40 bg-QWA2_TALENT_SHOW-gold/10 blur-3xl rounded-full" />
      <div className="absolute -bottom-10 left-10 w-40 h-40 bg-QWA2_TALENT_SHOW-red/10 blur-3xl rounded-full" />

      {/* CONTENT */}
      <div className="relative z-10 flex items-center justify-between h-[78px] px-5 md:px-8">

        {/* LEFT SIDE */}
        <a
          href="/"
          className="flex items-center gap-4 group"
        >

          {/* LOGO */}
          <div className="relative">

            <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-QWA2_TALENT_SHOW-red to-QWA2_TALENT_SHOW-gold opacity-0 blur-xl transition duration-500 group-hover:opacity-40" />

            <img
              src={logo}
              alt="Logo"
              className="relative w-12 h-12 md:w-14 md:h-14 rounded-2xl object-cover border border-white/10 transition-transform duration-500 group-hover:scale-105"
            />

          </div>

          {/* TEXT */}
          <div className="leading-none">

            <h1
              className={`font-black text-lg md:text-xl transition-colors duration-300 ${
                isScrolled ? 'text-black' : 'text-white'
              }`}
            >
              QwaQwa
            </h1>

            <p className="mt-1 text-[10px] uppercase tracking-[4px] font-bold text-QWA2_TALENT_SHOW-gold">
              Talent Show
            </p>

          </div>

        </a>

        {/* CENTER LINKS */}
        {/* RIGHT LINKS */}
<div className="hidden lg:flex items-center gap-2 ml-auto">

  {navLinks.map((link) => {

    const isActive = currentPath === link.href;

    return (
      <a
        key={link.name}
        href={link.href}
        className={`relative px-5 py-3 rounded-2xl text-sm font-bold uppercase tracking-[2px] transition-all duration-300 ${
          isActive
            ? 'text-white bg-gradient-to-r from-QWA2_TALENT_SHOW-red to-QWA2_TALENT_SHOW-gold shadow-lg'
            : isScrolled
            ? 'text-gray-700 hover:bg-gray-100'
            : 'text-white/80 hover:bg-white/10 hover:text-white'
        }`}
      >

        {link.name}

        {/* Active Glow */}
        {isActive && (
          <div className="absolute inset-0 rounded-2xl bg-white/10 blur-xl -z-10" />
        )}

      </a>
    );
  })}

</div>


        {/* MOBILE MENU BUTTON */}
        <button
          className={`md:hidden w-12 h-12 rounded-2xl flex items-center justify-center transition-all duration-300 ${
            isScrolled
              ? 'bg-gray-100 text-black'
              : 'bg-white/10 border border-white/10 text-white'
          }`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle mobile menu"
        >

          <div className="transition-transform duration-300">
            {isMobileMenuOpen ? (
              <X className="w-5 h-5" />
            ) : (
              <Menu className="w-5 h-5" />
            )}
          </div>

        </button>

      </div>

    </div>

  </div>

</nav>



            {/* MOBILE MENU BACKDROP */}
            <div
                className={`fixed top-0 left-0 right-0 bottom-0 z-30 md:hidden transition-all duration-300 ease-out ${isMobileMenuOpen ? 'opacity-100 bg-black/50 backdrop-blur-sm' : 'opacity-0 pointer-events-none'
                    }`}
                onClick={() => setIsMobileMenuOpen(false)}
                aria-hidden="true"
            />

            {/* MOBILE MENU DRAWER */}
            <div
                className={`fixed md:hidden top-0 right-0 h-screen pt-[90px] w-72 transform transition-all duration-300 ease-out z-40
    ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}
    ${isScrolled
                        ? 'bg-white/80 backdrop-blur-xl shadow-2xl'
                        : 'bg-white/60 backdrop-blur-xl shadow-xl'
                    }`}
            >
                <div className="flex flex-col h-full px-5 py-6">

                    {/* LINKS */}
                    <div className="space-y-2">
                        {navLinks.map(link => {
                            const isActive = currentPath === link.href;

                            return (
                                <a
                                    key={link.name}
                                    href={link.href}
                                    onClick={() => setIsMobileMenuOpen(false)}
                                    className={`group relative flex items-center justify-between px-4 py-3 rounded-xl text-sm uppercase tracking-wider font-medium transition-all duration-300
                        ${isActive
                                            ? ' bg-gradient-to-r from-QWA2_TALENT_SHOW-gold/10 to-QWA2_TALENT_SHOW-red/10 shadow'
                                            : 'text-gray-700 hover:bg-gray-100/70'
                                        }`}
                                >
                                    <span>{link.name}</span>

                                    {/* subtle arrow */}
                                    <span className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition">
                                        →
                                    </span>
                                </a>
                            );
                        })}
                    </div>

                    {/* DIVIDER */}
                    <div className="my-6 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>

                    {/* INFO SECTION */}
                    <div className="space-y-3 text-sm text-gray-600">
                        <p className="font-semibold text-gray-800 uppercase tracking-wide">
                            Contact
                        </p>

                        <a
                            href="mailto:qwa2talentshow@gmail.com"
                            className="block hover:text-QWA2_TALENT_SHOW-gold transition"
                        >
                            qwa2talentshow@gmail.com
                        </a>

                        <p className="text-xs text-gray-500">
                            Have questions or need support? Reach out anytime.
                        </p>
                    </div>

                    {/* SOCIALS */}
                    <div className="mt-6 flex items-center gap-4">
                        {/* <a href="#" className="w-10 h-10 rounded-full bg-QWA2_TALENT_SHOW-gold/20 flex items-center justify-center hover:bg-QWA2_TALENT_SHOW-gold transition-colors">
                            <Instagram className="w-5 h-5" />
                        </a>
                        <a href="#" className="w-10 h-10 rounded-full bg-QWA2_TALENT_SHOW-gold/20 flex items-center justify-center hover:bg-QWA2_TALENT_SHOW-gold transition-colors">
                            <Twitter className="w-5 h-5" />
                        </a> */}
                        <a href="https://www.facebook.com/profile.php?id=100083594971203" className="w-10 h-10 rounded-full bg-QWA2_TALENT_SHOW-gold/20 flex items-center justify-center hover:bg-QWA2_TALENT_SHOW-gold transition-colors">
                            <Facebook className="w-5 h-5" />
                        </a>
                        {/* <a href="#" className="w-10 h-10 rounded-full bg-QWA2_TALENT_SHOW-gold/20 flex items-center justify-center hover:bg-QWA2_TALENT_SHOW-gold transition-colors">
                            <Linkedin className="w-5 h-5" />
                        </a> */}
                    </div>


                </div>
            </div>
        </>
    );
}

export default Navigation;